<template>
  <v-dialog :value="show" persistent max-width="520" @input="$emit('close')">
    <v-card class="ec-card">
      <admin-table-subheader
        :title="isEdit ? 'Edit Partner' : 'New Partner'"
        close-button
        @close="$emit('close')"
      />

      <div class="rf-body">
        <v-form ref="form" v-model="valid">
          <label class="rf-label">Partner Name *</label>
          <v-text-field
            v-model="model.name"
            :rules="[v => !!v || 'Required']"
            dense outlined placeholder="AverMedia"
          />

          <label class="rf-label">Slug (optional — generated from name if empty)</label>
          <v-text-field
            v-model="model.slug"
            dense outlined placeholder="avermedia"
            :disabled="isEdit"
            :hint="isEdit ? 'Slug cannot be changed after creation' : ''"
            persistent-hint
          />

          <label class="rf-label">Contact Email</label>
          <v-text-field
            v-model="model.contact_email"
            dense outlined placeholder="partner@example.com"
          />

          <label class="rf-label">Commission Rate (%)</label>
          <v-text-field
            v-model.number="commissionPercent"
            type="number" min="0" max="100"
            dense outlined suffix="%"
          />

          <v-switch v-model="model.is_active" label="Active" color="primary" inset hide-details />

          <div v-if="formError" class="rf-error">
            <v-icon size="15" color="#dc2626" style="margin-right:6px">mdi-alert-circle-outline</v-icon>
            {{ formError }}
          </div>
        </v-form>
      </div>

      <div class="rf-footer">
        <button class="ec-btn ec-btn--ghost" @click="$emit('close')">Cancel</button>
        <button class="ec-btn ec-btn--primary" :disabled="saving" @click="save">
          <v-progress-circular v-if="saving" size="13" width="2" indeterminate style="margin-right:6px" />
          {{ isEdit ? 'Save' : 'Create' }}
        </button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { apiService } from '../../service/api.service'
import AdminTableSubheader from '../shared/AdminTableSubheader.vue'

export default {
  name: 'ResellerForm',
  components: { AdminTableSubheader },
  props: {
    show: { type: Boolean, default: false },
    reseller: { type: Object, default: null }
  },
  data () {
    const r = this.reseller
    return {
      valid: false,
      saving: false,
      formError: '',
      model: {
        name: r ? r.name : '',
        slug: r ? r.slug : '',
        contact_email: r ? r.contact_email : '',
        is_active: r ? !!r.is_active : true
      },
      commissionPercent: r ? Math.round(Number(r.commission_rate) * 100) : 30
    }
  },
  computed: {
    isEdit () { return !!this.reseller }
  },
  methods: {
    async save () {
      if (!this.$refs.form.validate()) return
      this.saving = true
      this.formError = ''
      const payload = {
        name: this.model.name,
        contact_email: this.model.contact_email || null,
        commission_rate: Number(this.commissionPercent) / 100,
        is_active: this.model.is_active
      }
      if (!this.isEdit && this.model.slug) payload.slug = this.model.slug

      const req = this.isEdit
        ? apiService.put(`admin/resellers/${this.reseller.id}`, payload)
        : apiService.post('admin/resellers', payload)

      await req
        .then(() => { this.$emit('saved') })
        .catch((err) => { this.formError = err.response?.data?.message || 'Operation failed' })
        .finally(() => (this.saving = false))
    }
  }
}
</script>

<style scoped>
.rf-body { padding: 18px 20px; }
.rf-label { display:block; font-size:.78rem; font-weight:600; color:var(--ec-text-2); margin-bottom:2px; }
.rf-footer { display:flex; justify-content:flex-end; gap:8px; padding:12px 20px; border-top:1px solid var(--ec-border); }
.rf-error { display:flex; align-items:center; margin-top:12px; padding:8px 12px; border-radius:8px; background:#fef2f2; color:#dc2626; font-size:.82rem; }
</style>
